<div
  *ngIf="showLoadersSubject | async"
  #outletContainer
  class="outlet-container"
  [ngStyle]="{
    height:height
  }"
>
  <div  class="loader-container"
      
        [ngStyle]="spinnerStyleObs | async"
  >
    <mat-progress-spinner 
      [strokeWidth]="strokeWidthObs | async" 
      [diameter]="diameterSubject | async"
      mode="indeterminate"
    >
    
    </mat-progress-spinner>

    <p>
      {{ (displayObs | async) }}
    </p>
  </div>


</div>